<template>
	<div class="j-page-header">
		<div class="j-page-header-content">
			<div class="d-flex align-items-center">
				<router-link :to="back" class="j-back-btn me-3">
					<font-awesome-icon :icon="['fas', 'arrow-left']" />
				</router-link>
				<div v-if="title">
					<h2 class="j-page-title">{{ title }}</h2>
					<p v-if="subtitle" class="j-page-subtitle">{{ subtitle }}</p>
				</div>
				<div v-else class="j-title-skeleton"></div>
				<div v-if="$slots['title-actions']" class="d-flex align-items-center gap-2 ms-3">
					<slot name="title-actions" />
				</div>
			</div>
			<div class="d-flex align-items-center gap-2">
				<ClientHeaderQuickActions v-if="clientEditId" :key="clientEditId" :client-id="clientEditId" />
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
import ClientHeaderQuickActions from '@/components/juniper/clients/ClientHeaderQuickActions.vue'

export default {
	name: 'JuniperPageHeader',
	components: { ClientHeaderQuickActions },
	props: {
		back: { type: String, required: true },
		title: { type: String, default: '' },
		subtitle: { type: String, default: '' },
	},
	computed: {
		// Any /juniper/clients/edit/:id subpage → quick actions appear in the
		// header on every client edit page, with no changes to the 19 views
		// that render this header.
		clientEditId() {
			const match = this.$route.path.match(/^\/juniper\/clients\/edit\/(\d+)/)
			return match ? match[1] : null
		},
	},
}
</script>

<style scoped>
.j-page-header {
	padding: 0 0 16px 0;
}
.j-page-header-content {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.j-back-btn {
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #ffffff;
	border: 1px solid #e0e1e1;
	border-radius: 50%;
	color: #64748b;
	text-decoration: none;
	transition: all 0.2s ease;
	flex-shrink: 0;
}
.j-back-btn:hover {
	background: #f8f9fa;
	border-color: #d1d5db;
	color: #475569;
	text-decoration: none;
}
.j-page-title {
	font-size: 18px;
	font-weight: 600;
	color: #111827;
	margin: 0 0 2px;
}
.j-page-subtitle {
	font-size: 13px;
	color: #6b7280;
	margin: 0;
}
.j-title-skeleton {
	width: 180px;
	height: 22px;
	background: #e5e7eb;
	border-radius: 6px;
	animation: jpulse 1.2s infinite;
}
@keyframes jpulse {
	0%, 100% { opacity: 1; }
	50% { opacity: 0.5; }
}
</style>
